module.exports = __webpack_public_path__ + "img/bounty.88a3d6f3.png";